<template>
  <div id="form-psoriasis" class="row card-collapse form-psoriasis" v-if="loading === false">
    <div class="documents">
      <div class="doc-link">{{t('Documents to download')}}:</div>
      <a class="doc-link" v-for="document in this.documents" target="_blank" :href="document.documentLink">{{document.name}}</a>
    </div>
    <titan-form ref="formApplicationType"
                v-if="showApplicationTypeForm"
                :schema="schemaApplicationType"
                v-on:saveData="$emit('saveData')"
                v-on:beforeSave="$emit('validate')"
                :showMessage="false"
                :model="formData"
                :editable="hasPermission('ApplicationsTitan', 'U')"
                :render-in-card="true"
                :show-action-button="false"
    />
    <titan-form
                ref="formAdditionalDoctorInfo"
                :schema="additionalDoctorInfo"
                v-if="showAdditionalDoctorInfoForm"
                v-on:saveData="$emit('saveData')"
                v-on:beforeSave="$emit('validate')"
                :showMessage="false"
                :model="formData"
                :show-action-button="false"
    />
    <patient-form ref="patientForm"
                  @saveData="saveData()"
                  @validate="isValid()"
                  :formData="formData.patient"
                  :editable="hasPermission('ApplicationsTitan', 'U') && !accepted"
                  :show-action-button="false"
    />
    <titan-form ref="contentForm"
                :schema="contentDataSchema"
                :model="formData.contentData"
                v-on:saveData="$emit('saveData')"
                v-on:beforeSave="$emit('validate')"
                :showMessage="false"
                :newItem="$route.name === 'createPatient'"
                :editable="hasPermission('ApplicationsTitan', 'U')"
                :show-action-button="false"
    />
    <div class="col-12 card-collapse">
      <div class="card" v-if="loadedAttachments">
        <div class="card-header">{{t('Attachments')}}</div>
        <div class="card-body row">
          <div class="col-6">
            <file-upload-with-encryption
              @addedFile="loadAttachmentsData()"
              :multiple="true"
              :api-url="uploadEncryptedFileUrl"
              :class="{'d-none': hasPermission('ApplicationsTitan', 'U') === false}"
            />
            <div class="mt-2" v-if="formData.applicationsAttachments.length === 0">
              {{t('Files were not attached to applications')}}
            </div>
          </div>
          <div class="col-6">
            <a :href="file.link"
               :key="file.id"
               :download="file.isClientEncrypted ? file.decryptedFilename : file.file"
               v-for="file in formData.applicationsAttachments"
               class="row file-row"
               target="_blank"
            >
              <div class="col col-lg-2 file-col-image">
                <img :src="file.link" :alt="file.file"
                     v-if="['jpg', 'png', 'gif'].includes(file.format)">
                <div class="file-icon" v-if="!(['jpg', 'png', 'gif'].includes(file.format))">
                  <font-awesome-icon icon="file"/>
                </div>
              </div>
              <div class="col col-lg-10">
                <div class="h3 mb-0">{{ file.isClientEncrypted ? file.decryptedFilename : file.name }}</div>
                <small>{{file.size | prettyBytes}}</small>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div id="main-save" class="main-save " :class="scrolledToBottom ? 'non-fixed':'fixed'">
      <b-button v-on:click="$emit('saveData')" variant="primary">{{t('Save')}}</b-button>
    </div>
  </div>

</template>

<script>
    import TitanForm from '../../../core/Form/Form'
    import FileUpload from './file-upload'
    import FileUploadWithEncryption from './file-upload-with-encryption'
    import VueFormGenerator from 'vue-form-generator';
    import {validateMultipleForms} from '../../../core/Libs/utils';
    import EpicrisisPattern from './epicrisis-pattern';
    import {apiLink} from '../../../store/api'
    import TimeLine from '../../../core/TimeLine';
    import AcceptAction from '../../../core/AcceptAction';
    import FormGenerator from '../../../core/Form/vfg/formGenerator';
    import FieldRadios from 'vue-form-generator';
    import PatientForm from '../patients/form';
    import {get, set} from 'lodash';

    export default {
        components: {
            AcceptAction,
            TimeLine,
            EpicrisisPattern,
            TitanForm,
            FileUpload,
            PatientForm,
            FieldRadios,
            FileUploadWithEncryption,
            'vue-form-generator': FormGenerator
        },
        props: {
            formData: {
                type: Object,
                required: true,
            },
            accepted: {
                type: Boolean,
                default: true,
            }
        },
        created() {
            //this.positionActionPanel();
            window.addEventListener('scroll', this.positionActionPanel);
            window.addEventListener('resize', this.positionActionPanel);

        },
        mounted() {

            this.loadDocuments();
            let aoForms = Object.values(this.formData.protocol.schema.forms);
            aoForms.forEach(formDef => {
                let formSchema = {
                    name: formDef.label,
                    type: 'main',
                    model: formDef.variable,
                    fields: []
                };
                let aoFields = Object.values(formDef.fields);
                aoFields = aoFields.sort((a, b) => (a.order > b.order) ? 1 : -1);
                aoFields.forEach(fieldDef => {
                    fieldDef.frontSchema.formModel = formSchema.model;
                    formSchema.fields.push(fieldDef.frontSchema);
                });
                this.contentDataSchema.push(formSchema);
            });
            this.getAllFieldSchemas().forEach(fieldSchema => {
                if (fieldSchema.required) {
                    fieldSchema.validator = VueFormGenerator.validators.required;
                }
                if (fieldSchema.label.includes('{')) {
                    fieldSchema.labelTemplate = fieldSchema.label;
                    let fieldVar = fieldSchema.label.match(/\{([^)]+)\}/)[1];
                    fieldSchema.label = fieldSchema.labelTemplate.replace('{' + fieldVar + '}', '');
                    let replaceFieldSchema = this.getFieldSchema(fieldVar);
                    if (typeof replaceFieldSchema === 'object' && replaceFieldSchema !== null) {
                        replaceFieldSchema.onChanged = (model, newVal, oldVal, changedField) => {
                            if (typeof newVal === 'object' && newVal !== null && newVal.hasOwnProperty('value')) {
                                newVal = newVal.name;
                            }
                            if (newVal === null) newVal = '';
                            fieldSchema.label = fieldSchema.labelTemplate.replace('{' + fieldVar + '}', newVal);
                        };
                    }
                }
                if (typeof fieldSchema.visible === 'string' && fieldSchema.visible.length > 0) {
                    let subConditions = fieldSchema.visible.split('&');
                    let conditionsDef = [];
                    subConditions.forEach(subCond => {
                        let defParts = subCond.replace(/\s+/g, '').split('=');

                        conditionsDef.push({
                            'fieldModel': {'form': fieldSchema.formModel, 'field': defParts[0]},
                            'expectedValue': defParts[1].replace('(', '').replace(')', '').split(',')
                        })
                    });
                    fieldSchema.visible = (model) => {
                        let result = 1;
                        conditionsDef.forEach(cond => {
                            let condField = model[cond.fieldModel.form][cond.fieldModel.field];
                            let condFieldValue = null;
                            if (typeof condField === 'object' && condField !== null && condField.hasOwnProperty('value')) {
                                condFieldValue = condField.value.toString();
                            } else if (condField !== null) {
                                condFieldValue = condField.toString();
                            }
                            result *= cond.expectedValue.includes(condFieldValue);
                        });
                        return Boolean(result);
                    };
                }

                if (typeof fieldSchema.disabled === 'string' && fieldSchema.disabled.length > 0) {
                    let subConditions = fieldSchema.disabled.split('&');
                    let conditionsDef = [];
                    subConditions.forEach(subCond => {
                        let defParts = subCond.replace(/\s+/g, '').split('=');
                        conditionsDef.push({
                            'fieldModel': {'form': fieldSchema.formModel, 'field': defParts[0]},
                            'expectedValue': defParts[1].replace('(', '').replace(')', '').split(',')
                        })
                    });
                    fieldSchema.disabled = (model) => {
                        let result = 1;
                        conditionsDef.forEach(cond => {
                            let condField = model[cond.fieldModel.form][cond.fieldModel.field];
                            let condFieldValue = null;
                            if (typeof condField === 'object' && condField !== null && condField.hasOwnProperty('value')) {
                                condFieldValue = condField.value.toString();
                            } else if (condField !== null) {
                                condFieldValue = condField.toString();
                            }
                            result *= cond.expectedValue.includes(condFieldValue);
                        });
                        return Boolean(result);
                    };
                }

            });

            setTimeout(() => {
                this.scrolledToBottom = false;
                this.resizeActionPanel();
                this.loadedAttachments = true;
            }, 50);
        },
        watch: {},
        computed: {
            uploadFileUrl() {
                return apiLink() + 'applications/upload-file/' + this.$route.params.id + '?XDEBUG_SESSION_START=titan';
            },
            uploadEncryptedFileUrl() {
                return apiLink() + 'applications/upload-file-encrypted/' + this.$route.params.id + '?XDEBUG_SESSION_START=titan';
            },
            insuranceCode() {
                return !this.formData.patient.insurance ? null : this.formData.patient.insurance.code;
            },
            showAdditionalDoctorInfoForm() {
                if(this.showApplicationTypeForm && this.doctorRole && [1, 2].includes(this.doctorRole)) {
                   return true;
                }
                else {
                    return false;
                }
            },
            showApplicationTypeForm() {
                 return this.formData.protocol.id !== 13;
            },
            doctorRole() {
                return this.formData.addDocRole;
            }
        },
        methods: {
            getAllFieldSchemas() {
                let allFieldSchemas = [];
                this.contentDataSchema.forEach(formSchema => {
                    let formFields = Object.values(formSchema.fields);
                    formFields.forEach(fieldSchema => {
                        allFieldSchemas.push(fieldSchema);
                    })
                });
                return allFieldSchemas;
            },
            getFieldSchema(variable) {
                let found = this.getAllFieldSchemas().filter(f => f.model === variable);
                if (Array.isArray(found) && found.length === 1) {
                    return found[0];
                }
                return null;
            },
            getFieldValue(variable) {
                let found = null;
                Object.values(this.formData.contentData).forEach(fields => {
                    if (fields.hasOwnProperty(variable)) {
                        found = fields[variable];
                    }
                });
                return found;
            },
            resizeActionPanel() {
                let el = document.querySelector('#form-psoriasis');
                if (el) {
                    let bb = el.getBoundingClientRect();
                    let width = bb.right - bb.left;
                    document.getElementById('main-save').style.width = width + 'px';

                }
            },
            positionActionPanel() {
                setTimeout(() => {
                    let bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + (window.innerHeight + 125) > document.documentElement.offsetHeight
                    if (bottomOfWindow) {
                        this.scrolledToBottom = true;

                    } else {
                        this.resizeActionPanel();
                        this.scrolledToBottom = false;
                    }
                }, 100)
            },
            index(obj, i) {
                return obj[i]
            },
            eraseHiddenValues() {
                //console.log('TODO: should erase hidden values');
            },
            isValid() {
                //this.eraseHiddenValues();
                return validateMultipleForms([
                    this.$refs.formApplicationType,
                    this.$refs.formAdditionalDoctorInfo,
                    this.$refs.patientForm,
                    this.$refs.contentForm
                ]);
            },
            loadAttachmentsData() {
                this.$store.dispatch('applications/attachments', this.$route.params.id);
            },
            loadDocuments() {
                let tags = [
                    'exception_blitzima_castlem',
                    'exception_blitzima_GVHD',
                    'exception_blitzima_MCL_2',
                    'exception_blitzima_NHL_do_1220',
                    'exception_Bortezomib_MM',
                    'exception_blitzima_castleman',
                    'exception_blitzima_MCL_3',
                    'exception_bortezomib_amyloidoza_20'
                ];
                this.$store.dispatch('documents/list',{'page':0}).then(response => {
                    response.items.forEach(doc => {
                        if(tags.includes(doc.tag)) {
                            this.documents.push(doc)
                        }
                    });
                });
            }
        },
        data() {
            return {
                documents: [],
                scrolledToBottom: false,
                formOptions: {
                    validateAfterLoad: false,
                    validateAfterChanged: false
                },
                loading: false,
                loadedAttachments: false,
                schemaApplicationType: [
                    {
                        name: this.t('Role in application'),
                        type: 'main',
                        fields: [
                            {
                                type: 'radios',
                                label: this.t('My role in application'),
                                styleClasses: 'col-12 radios-float',
                                model: 'addDocRole',
                                values: [
                                    {value: 1, name: this.t('Indicating physician')},
                                    {value: 2, name: this.t('Attending physician')},
                                    {value: 3, name: this.t('Both attending and indicating physician')},
                                ],
                                required: true,
                                validator: VueFormGenerator.validators.required,
                                disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                            }
                        ]
                    }
                ],
                additionalDoctorInfo: [
                    {
                        name: () => {
                            return (this.doctorRole === 2) ? this.t('Indicating physician') : this.t('Attending physician')
                        },
                        type: 'main',
                        fields: [
                            {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Physician code'),
                                styleClasses: 'col-12',
                                model: 'addDocPhysicianCode',
                                required: true,
                                validator: VueFormGenerator.validators.required,
                            },
                            {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Title prefix'),
                                styleClasses: 'col-2',
                                model: 'addDocTitlePrefix',
                                required: false,
                                max: 40,
                                validator: VueFormGenerator.validators.string
                            },
                            {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Firstname'),
                                styleClasses: 'col-4',
                                model: 'addDocFirstname',
                                required: true,
                                validator: VueFormGenerator.validators.required
                            },
                            {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Lastname'),
                                styleClasses: 'col-4',
                                model: 'addDocLastname',
                                required: true,
                                validator: VueFormGenerator.validators.required
                            },
                            {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Title sufix'),
                                styleClasses: 'col-2',
                                model: 'addDoctitleSufix',
                                required: false,
                                max: 40,
                                validator: VueFormGenerator.validators.string
                            },
                            {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Provider code'),
                                styleClasses: 'col-4',
                                model: 'addDocProviderCode',
                                required: true,
                                validator: VueFormGenerator.validators.required
                            },
                            {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Company name') + ' / ' + this.t('Facility name'),
                                styleClasses: 'col-8',
                                model: 'addDocCompanyName',
                                required: true,
                                validator: VueFormGenerator.validators.required
                            },
                            {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Street'),
                                styleClasses: 'col-4',
                                model: 'addDocStreet',
                                required: true,
                                validator: VueFormGenerator.validators.required
                            },
                            {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('City'),
                                styleClasses: 'col-4',
                                model: 'addDocCity',
                                required: true,
                                validator: VueFormGenerator.validators.required
                            },
                            {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('ZIP'),
                                styleClasses: 'col-4',
                                model: 'addDocZip',
                                required: true,
                                validator: VueFormGenerator.validators.required
                            },
                            {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('VAC'),
                                styleClasses: 'col-4',
                                model: 'addDocVac'
                            },
                            {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Phone'),
                                styleClasses: 'col-4',
                                model: 'addDocPhone',
                                required: true,
                                validator: VueFormGenerator.validators.required
                            },
                            {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('E-mail'),
                                styleClasses: 'col-4',
                                model: 'addDocEmail',
                                required: false,
                                validator: VueFormGenerator.validators.email
                            },
                        ]
                    }
                ],
                contentDataSchema: []

            }
        }
    }
</script>

<style lang="scss">
  .vue-form-generator {
    .grid-subform {
      padding-bottom: 10px;
      border-top: 1px solid transparent;
      border-bottom: 1px solid transparent;

      &:hover {
        background: #efefef;
        border-bottom: 1px solid #dadada;
        border-top: 1px solid #dadada;
      }

      label span {
        /*display: inline !important;*/
      }

      .field-titanSwitch {

        .field-wrap {
          position: absolute;
          top: 10px;
        }

        label {
          position: absolute;
          top: 10px;
          left: 75px;

          span {
            display: inline;
          }
        }
      }

    }
  }

  .form-psoriasis {
    .documents {
       padding:0.5rem;
    }
    .doc-link {
      display:block;
      float:left;
      padding:0.2rem 0.5rem;

    }
    .file-row {
      margin-left: 0;
      margin-top: 0;
    }

    .main-save {
      &.fixed {
        /*box-shadow: 0px -3px 2px 1px #efefef;*/
        position: fixed;
        bottom: 0;
        border: 0;
        border-top: 2px solid rgba(0, 0, 0, 0.125);
        border-radius: 0;
      }

      &.non-fixed {
        width: 100%;
        border-top-left-radius: 0;
        border-top-right-radius: 0;
        background: white;

      }

      z-index: 1000;
      background: #efefef;
      text-align: center;
      padding-top: 1rem;
      padding-bottom: 1rem;
      border: 1px solid rgba(0, 0, 0, 0.125);
      border-top: 0;
      border-radius: .25rem;
    }

    .form-group.left-float {
      & > label {
        float: left;
        width: 10%;
      }

      .field-wrap {
        float: left;
        margin-left: 0.5rem;
      }
    }

    .form-group.radios-float {
      & > label {
        float: left;
        width: 20%;
      }

      .field-wrap {
        float: left;
        margin-left: 1rem;
      }
    }

    .form-control {
      border-color: #b3b8bd !important;
    }

    .field-label {
      span {
        font-size: 1.2rem;
        margin-left: 0 !important;
      }
    }

    label {
      font-size: 0.9rem;
    }

    legend {
      padding-top: 0.6rem;
      font-size: 1.2rem;
    }

    .titan-select {
      .multiselect__tags {
        border-color: #b3b8bd !important;
      }
    }

    .titan-switch {
      height: 26px;
      line-height: 26px;
      padding-left: 28px !important;
      font-size: 0.9rem;

      &.switch-off {
        background-color: gray !important;
        padding-left: 6px !important;
      }

      &.switch-on {
        background-color: #3ac165 !important;
        padding-right: 5px !important;

      }
    }

    .titan-form {
      .label-left {
        label {
          float: left;
          padding-top: 0.4em;
          margin-right: 0.4em;
        }

        .field-wrap {
          float: left;
        }
      }

      .label-right {
        label {
          padding-top: 0.6em;
          margin-left: 1em;
        }

        .field-wrap {
          float: left;
          width: 15%;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/private/applications/hema-form.vue